import gql from "graphql-tag";

import client from "../../apollo";
import { LS_BADGE_CACHE } from "../../config";
import { getCurrentUserFromCache } from "../currentUser";

import ObtainBadgeMutation from './ObtainBadgeMutation.graphql';

export const obtainBadge = async (badgeId) => {
    try {
        // Get user
        const user = getCurrentUserFromCache();
        if (user && user?.me) {

            // Check badges
            const badges = JSON.parse(localStorage.getItem(LS_BADGE_CACHE) || '[]');
            if (badges.includes(badgeId)) {
                return;
            }

            const raw = await client.mutate({
                mutation: gql(ObtainBadgeMutation),
                variables: { input: { badgeId } }
            }).catch(() => null);

            if (!raw?.errors) {
                localStorage.setItem(LS_BADGE_CACHE, JSON.stringify([...badges, badgeId]));
            }
        }
    } catch (err) { } // eslint-disable-line no-empty
};
